export enum AddServiceSteps {
  checkService,
  serviceExists,
  serviceConnect
}
